import { IUser, IUserData, ILicenseUpdatedResult } from './types';

export const initialState: IUser = {
  pin: '',
  site: '',
  role: 'Visitor',
  isAuthenticated: false,
  hasValidLicense: true,
  licenseHasExpired: false,
  numberOfSites: 0
};

export interface IAction {
  type: string;
  payload?: any;
}

const LOGIN_SUCCEEDED = 'LOGIN_SUCCEEDED';
const LOGOUT_SUCCEEDED = 'LOGOUT_SUCCEEDED';
const LICENSE_UPDATED = 'LICENSE_UPDATED';

export const loginSucceeded = (userData: IUserData): IAction => ({
  type: LOGIN_SUCCEEDED,
  payload: userData,
});

export const logoutSucceeded = (): IAction => ({
  type: LOGOUT_SUCCEEDED,
});

export const licenseUpdated = (payload: ILicenseUpdatedResult): IAction => ({
  type: LICENSE_UPDATED,
  payload
});

export const userReducer = (state: IUser, action: IAction): IUser => {
  const { type, payload } = action;

  switch (type) {
    case LOGIN_SUCCEEDED:
      return { ...payload, isAuthenticated: true };

    case LOGOUT_SUCCEEDED:
      return initialState;

    case LICENSE_UPDATED:
      return { ...state, ...payload, hasValidLicense: true, licenseHasExpired: false };

    default:
      throw new Error();
  }
};
